import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { updateTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/api-actions'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'

export const useChangeStartDate = (): {
  handleChangeDate: (date: string | Date) => void
} => {
  const dispatch = useAppDispatch()

  const scheduledTikTokCampaign = useAppSelector(getScheduledTikTokCampaign)

  const handleChangeDate = useCallback(
    (date: string | Date): void => {
      if (scheduledTikTokCampaign?.id) {
        void dispatch(
          updateTikTokCampaign({
            id: Number(scheduledTikTokCampaign.id),
            startDate: date,
            comment: scheduledTikTokCampaign.comment || '',
          }),
        )
      }
    },
    [dispatch, scheduledTikTokCampaign],
  )

  return {
    handleChangeDate,
  }
}
